"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIsExecutionResultExportableToXlsxByRef = exports.selectIsExecutionResultExportableToCsvByRef = exports.selectIsExecutionResultReadyForExportByRef = exports.selectExecutionResultByRef = exports.selectExecutionResult = void 0;
// (C) 2021-2022 GoodData Corporation
var toolkit_1 = require("@reduxjs/toolkit");
var sdk_model_1 = require("@gooddata/sdk-model");
var selectors_1 = require("../_infra/selectors");
var executionResultsEntityAdapter_1 = require("./executionResultsEntityAdapter");
var layoutSelectors_1 = require("../layout/layoutSelectors");
var errorPredicates_1 = require("../../../_staging/errors/errorPredicates");
var permissionsSelectors_1 = require("../permissions/permissionsSelectors");
var configSelectors_1 = require("../config/configSelectors");
var backendCapabilitiesSelectors_1 = require("../backendCapabilities/backendCapabilitiesSelectors");
var selectSelf = toolkit_1.createSelector(function (state) { return state; }, function (state) { return state.executionResults; });
var adapterSelectors = executionResultsEntityAdapter_1.executionResultsAdapter.getSelectors(selectSelf);
var selectExecutionResultEntities = adapterSelectors.selectEntities;
/**
 * @alpha
 */
exports.selectExecutionResult = adapterSelectors.selectById;
/**
 * @alpha
 */
exports.selectExecutionResultByRef = selectors_1.createMemoizedSelector(function (ref) {
    return toolkit_1.createSelector(selectExecutionResultEntities, function (executionResults) {
        var key = sdk_model_1.serializeObjRef(ref);
        return executionResults[key];
    });
});
/**
 * @alpha
 */
exports.selectIsExecutionResultReadyForExportByRef = selectors_1.createMemoizedSelector(function (ref) {
    return toolkit_1.createSelector(exports.selectExecutionResultByRef(ref), layoutSelectors_1.selectAnalyticalWidgetByRef(ref), function (widgetExecution) {
        if (!widgetExecution) {
            return false;
        }
        var isLoading = widgetExecution.isLoading, error = widgetExecution.error, executionResult = widgetExecution.executionResult;
        return !!executionResult && !isLoading && !errorPredicates_1.isNonExportableError(error);
    });
});
/**
 * @alpha
 */
exports.selectIsExecutionResultExportableToCsvByRef = selectors_1.createMemoizedSelector(function (ref) {
    return toolkit_1.createSelector(backendCapabilitiesSelectors_1.selectSupportsExportToCsv, exports.selectIsExecutionResultReadyForExportByRef(ref), permissionsSelectors_1.selectCanExportTabular, permissionsSelectors_1.selectCanExecuteRaw, configSelectors_1.selectSettings, function (supportsCapabilityCsv, isReadyForExport, canExportTabular, canExecuteRaw, settings) {
        var isExportEnabled = Boolean(settings.enableKPIDashboardExport && canExportTabular);
        var isRawExportEnabled = Boolean(isExportEnabled && canExecuteRaw);
        return supportsCapabilityCsv && isReadyForExport && isRawExportEnabled;
    });
});
/**
 * @alpha
 */
exports.selectIsExecutionResultExportableToXlsxByRef = selectors_1.createMemoizedSelector(function (ref) {
    return toolkit_1.createSelector(backendCapabilitiesSelectors_1.selectSupportsExportToXlsx, exports.selectIsExecutionResultReadyForExportByRef(ref), permissionsSelectors_1.selectCanExportTabular, configSelectors_1.selectSettings, function (supportCapabilityXlsx, isReadyForExport, canExportTabular, settings) {
        var isExportEnabled = Boolean(settings.enableKPIDashboardExport && canExportTabular);
        return supportCapabilityXlsx && isReadyForExport && isExportEnabled;
    });
});
//# sourceMappingURL=executionResultsSelectors.js.map